import Api from '@/axios'

export default {
  getHomeData () {
    return Api().get('pages/homepages')
  }
}
